<mat-card appearance="outlined">
  <div class="options-container">
    <mat-radio-group [value]="timeRangeSelected$ | async" (change)="radioButtonChange($event)">
      @for (option of timeRangeOptions; track option) {
        <mat-radio-button [value]="option.key">
          {{ option.i18nName | translate }}
        </mat-radio-button>
      }
    </mat-radio-group>
    @if (timeRangeSelected$ | async; as selectedTR) {
      @if (selectedTR === 'custom' || selectedDateValue === 'custom') {
        <div class="custom-date-range">
          <div class="date-input-wrapper">
            <mat-form-field>
              <input
                matInput
                readonly
                [matDatepicker]="startPicker"
                placeholder="Start date"
                (dateChange)="onStartChange($event.value)"
                [value]="dateRange[0]"
                [max]="dateRange[1]"
                />
              <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="date-input-wrapper">
            <mat-form-field>
              <input
                matInput
                readonly
                [matDatepicker]="endPicker"
                placeholder="End date"
                (dateChange)="onEndChange($event.value)"
                [value]="dateRange[1]"
                [min]="dateRange[0]"
                [max]="maxDateRange"
                />
              <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      }
    }
  </div>
  <div class="actions-container">
    <button mat-button color="accent" (click)="close()">Cancel</button>
    <button mat-raised-button color="accent" (click)="setDateRange()">Apply</button>
  </div>
</mat-card>
